import { render, staticRenderFns } from "./ModalTicketIframe.vue?vue&type=template&id=298cedd6&scoped=true&"
import script from "./ModalTicketIframe.vue?vue&type=script&lang=js&"
export * from "./ModalTicketIframe.vue?vue&type=script&lang=js&"
import style0 from "./ModalTicketIframe.vue?vue&type=style&index=0&id=298cedd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298cedd6",
  null
  
)

export default component.exports